module.exports = __webpack_public_path__ + "static/img/hahmo-mita-tekijanoikeus-tarkoittaa.4adee29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hahmo-mita-tekijanoikeus-tarkoittaa.png
// module id = A6NL
// module chunks = 1